// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"71494cda","629":"01ba4c54"}[chunkId] + ".chunk.js";
};